import { convertNumber } from "utils"
import { ValueSchema } from "../types"

type BottomSectionProps = { 
  label?: string
  value?: ValueSchema
  className?: string
}

export const BottomSection:React.FC<BottomSectionProps> = ({ label, value, className }) => (
    <div className={`mx-5 mt-2 w-full ${className}`}>
      <div className="bg-black dark:bg-black border-[1px] border-[#3c3c3c]">
        <div className="label-text my-1 text-center text-white">{label ?? ""}</div>
      </div>
      <div className="flex w-full">
        <div className="border border-[#3c3c3c] h-[100px] text-center w-full px-2">
          <div className="text-sm"><span className="text-gray-600">LAST MONTH</span></div>
          <div className="text-xl">{value?.last_month ? convertNumber(value?.last_month)?.intoCurrency : "0"}</div>
        </div>
        <div className="border border-[#3c3c3c] h-[100px] text-center mx-1 w-full px-2">
          <div className="text-sm text-gray-500!"><span className="text-gray-600">THIS MONTH</span></div>
          <div className="text-xl">{value?.this_month ?  convertNumber(value?.this_month)?.intoCurrency : "0"}</div>
        </div>
        <div className="border border-[#3c3c3c] h-[100px] text-center w-full px-2">
          <div className="text-sm text-gray-500!"><span className="text-gray-600">BUDGET</span></div>
          <div className="text-xl">{value?.budget ?  convertNumber(value?.budget)?.intoCurrency : "0"}</div>
        </div>
      </div>
    </div>
  )